import { Component } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-tiktok-videopost',
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    RouterLink,
    MatIconModule
  ],
  templateUrl: './tiktok-videopost.component.html',
  styleUrl: './tiktok-videopost.component.scss'
})
export class TikTokVideopostComponent {
  loading = false;
  errorMessage = '';

  siteDomain = 'psg';
  postFeed = 'psg';
  postDescription = 'Happy birthday @Ousmane Dembélé 🎉 🔥 #PSG #Dembele #Ligue1 #UCL #SportsTikTok';
  formattedDate = '';

  thumbnailFilePath = './assets/images/na.png';
  mainImageUrl = './assets/images/na.png';
  videoUrl = '';

  likesCount = '1.2M';
  commentsCount = '12.1K';
  savesCount = '76.4K';
  sharesCount = '41.1K';
}